import { useOutletContext } from "react-router-dom";
import { Network } from "lucide-react";
import { portalApi } from "./api";
import { ModuleProfileCard } from "../../components/portal/ModuleProfile";
import CounterpartyManager from "../../components/portal/CounterpartyManager";

export default function PortalNetwork() {
  const { me } = useOutletContext();
  const canEdit = me.user.account_type === "client_admin";

  return (
    <main className="mx-auto max-w-7xl px-4 py-10 sm:px-6" data-testid="portal-network">
      <div className="flex flex-wrap items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-600/10 text-emerald-700">
          <Network className="h-5 w-5" />
        </span>
        <div>
          <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-800/70">India module</div>
          <h1 className="font-display text-2xl font-bold text-forest-deep sm:text-3xl">Supply chain network</h1>
        </div>
      </div>
      <p className="mt-3 max-w-3xl text-sm leading-relaxed text-forest-deep/65">
        Track who {me.org.legal_name} buys from and sells to, then click any compliance number to inspect that exact list.
      </p>

      <div className="mt-6">
        <ModuleProfileCard profile={me.org.module_profile} />
      </div>

      <CounterpartyManager api={portalApi} basePath="/client/counterparties" canEdit={canEdit} orgName={me.org.legal_name} />
    </main>
  );
}
